import classNames from 'classnames';
import React from 'react';
import { TextInputProps } from './types';

const TextInput: React.FC<TextInputProps> = ({
  label,
  name,
  id,
  value,
  autoComplete,
  disabled,
  placeholder,
  type,
  error,
  required,
  onChange,
  register,
  validation
}: TextInputProps) => {
  const inputClasses = classNames(
    'bg-rt-input border border-white border-opacity-30 h-12 px-4 text-white w-full appearance-none rounded-none',
    {}
  );

  const validationRules = validation || {};

  return (
    <div className="mb-3">
      {label ? (
        <label className="text-white mb-2 block text-sm" htmlFor={id}>
          {label}
        </label>
      ) : null}
      <input
        {...register(id, { required, ...validationRules })}
        className={inputClasses}
        aria-describedby={error ? `${name}-error` : undefined}
        aria-invalid={!!error}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        id={id}
        name={name}
        autoComplete={autoComplete}
        defaultValue={value}
        onChange={onChange}
      />
      {error ? (
        <span role="alert" className="text-sm text-red-500" id={`${name}-error`}>
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default TextInput;
